export default __webpack_public_path__ + "img/6d2153f62477ce0c2f01d50e3d5567c8.png";